import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useStudentClassroomPost = () => {
  const setStudentClassroom = useCallback((payload) => {
    return new Request(`${MONOLITH_ORIGIN}/api/v2/student-classroom/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(setStudentClassroom);
};

export default useStudentClassroomPost;
